import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';

import Home from './pages/Home';
import Courses from './pages/Courses';
import Teachers from './pages/Teachers';

import News from './pages/News';
import Schedule from './pages/Schedule';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminLayout from './components/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import AdminAddNotification from './pages/admin/AdminAddNotification';

import AdminTeachers from './pages/admin/AdminTeachers';
import AdminSchedule from './pages/admin/AdminSchedule';
import ProtectedRoute from './components/common/ProtectedRoute';
import CurriculumProgram from './pages/CurriculumProgram';

import Profile from './pages/Profile';
import TeacherDetail from './pages/TeacherDetail';
import NewsDetail from './pages/NewsDetail'; // thêm dòng này
import './App.css';

const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {!isAdminRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/khoa-hoc" element={<Courses />} />
        <Route path="/giao-vien" element={<Teachers />} />
        
        <Route path="/tin-tuc" element={<News />} />
        <Route path="/tin-tuc/:id" element={<NewsDetail />} /> {/* thêm dòng này */}
        <Route path="/lich-hoc" element={<Schedule />} />
        <Route path="/dang-nhap" element={<Login />} />
        <Route path="/dang-ky" element={<Register />} />
        <Route path="/quen-mat-khau" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/chuong-trinh-bo-giao-duc" element={<CurriculumProgram />} />
        
        <Route path="/ho-so" element={<Profile />} />
        <Route path="/giao-vien/:id" element={<TeacherDetail />} />
        
        {/* Admin Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="notification" element={<AdminAddNotification />} />
            
            <Route path="teachers" element={<AdminTeachers />} />
            <Route path="schedule" element={<AdminSchedule />} />
          </Route>
        </Route>
      </Routes>
      
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
